// @flow

import React, { Component } from 'react';
import Alert from 'react-s-alert';

import App from './App.jsx';
import Login from './Login.jsx';

import Role from './roles.js';

import {DOMAIN} from './consts.js';

import type {T_User} from './types.js';




type T_Launcher = {
 user  : ?T_User,
 height: number,
 width : number
};



export default class Launcher extends Component<T_Launcher, T_Launcher> {
  post_login: (user: T_User) => void;
  
  
  
  constructor(props: T_Launcher) {
    super(props);
    
    this.state = {
      user  : props.user,
      height: props.height,
      width : props.width
    };
    
    window.onresize = () => {
      this.setState({
        height: window.innerHeight,
        width : window.innerWidth
      });
    };
    
    this.post_login = this.post_login.bind(this);
  }
  
  
  
  post_login(user: T_User): void {
    this.setState({user});
  }
  
  
  
  render() {
    let max_alerts = 5;
    
    if (this.state.user != null) {
      if (! Role.is_agrosat_user(this.state.user.role)) {
        max_alerts = 1;
      }
    }
    
    return (
      <div>
        <Alert stack={{limit: max_alerts}} />
        
        {this.state.user ?
          <App
            user={this.state.user}
            domain={DOMAIN}
            height={this.state.height}
            width={this.state.width}
            launcher={this}
          />
        :
          <Login
            domain={DOMAIN}
            width={this.state.width}
            height={this.state.height}
            on_checked={this.post_login}
          />
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Launcher.jsx